<template>
    <div>        
        <main class="container-wrap">
        <section class="banner">
            <img :src="isEnglish() ? require('../images/en-banner.png'): require('../images/ch-banner.png')">
        </section>
        <section class="index-top-wrap v2-wrap">
            <div class="v2">
                <div data-aos="fade-up" data-aos-delay="100" class="colorful-wrap aos-init aos-animate">
                    <div class="colorful-bg">
                        <p data-aos="fade-up" data-aos-delay="150" class="colorful-text aos-init aos-animate"
                            :class="getCurrentLang()">
                            <span class="colorful-title">{{$tt('即刻')}} </span>

                            {{$tt('开始创建属于您的品牌')}}
                        </p>
                        <div class="scroll-wrap">
                            <p class="scroll-text pc">SCROLL</p>
                            <p class="scroll-text device">SCROLL</p>
                        </div>
                    </div>
                </div>
                <div class="desert-wrap">
                    <div id="desert-obj" style="transform: translate3d(0px, 0px, 0px) rotate(0.0001deg); transform-style: preserve-3d; backface-visibility: hidden; pointer-events: none;">
                        <div class="desert-half-r" style="transform: translate3d(0px, 0px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: relative; display: block; left: 0px; top: 0px;">
                            <div class="ball-stage-3">
                                <div class="ball-svg b3_1">
                                    <svg>
                                        <symbol id="maskArea3_1">
                                            <g id="maskCir3_1" stroke="#FFF" fill="#FFF">
                                                <circle r="80" cx="80" cy="80"></circle>
                                            </g>
                                        </symbol>
                                        <mask id="maskScope3_1">
                                            <use xlink:href="#maskArea3_1"></use>
                                        </mask>
                                        <g mask="url(#maskScope3_1)">
                                            <image xlink:href="../images/cloud3_1.png" width="100%" height="100%"
                                                preserveAspectRatio="xMidYMid slice"></image>
                                        </g>
                                    </svg>
                                </div>
                                <div class="ball-svg b3_2">
                                    <svg>
                                        <symbol id="maskArea3_2">
                                            <g id="maskCir3_2" stroke="#FFF" fill="#FFF">
                                                <circle r="60" cx="60" cy="60"></circle>
                                            </g>
                                        </symbol>
                                        <mask id="maskScope3_2">
                                            <use xlink:href="#maskArea3_2"></use>
                                        </mask>
                                        <g mask="url(#maskScope3_2)">
                                            <image xlink:href="../images/cloud3_2.png" width="100%" height="100%"
                                                preserveAspectRatio="xMidYMid slice"></image>
                                        </g>
                                    </svg>
                                </div>
                                <div class="ball-svg b3_3">
                                    <svg>
                                        <symbol id="maskArea3_3">
                                            <g id="maskCir3_3" stroke="#FFF" fill="#FFF">
                                                <circle r="80" cx="80" cy="80"></circle>
                                            </g>
                                        </symbol>
                                        <mask id="maskScope3_3">
                                            <use xlink:href="#maskArea3_3"></use>
                                        </mask>
                                        <g mask="url(#maskScope3_3)">
                                            <image xlink:href="../images/cloud3_3.png" width="100%" height="100%"
                                                preserveAspectRatio="xMidYMid slice"></image>
                                        </g>
                                    </svg>
                                </div>
                                <div class="ball-svg b3_4">
                                    <svg>
                                        <symbol id="maskArea3_4">
                                            <g id="maskCir3_4" stroke="#FFF" fill="#FFF">
                                                <circle r="70" cx="70" cy="70"></circle>
                                            </g>
                                        </symbol>
                                        <mask id="maskScope3_4">
                                            <use xlink:href="#maskArea3_4"></use>
                                        </mask>
                                        <g mask="url(#maskScope3_4)">
                                            <image xlink:href="../images/cloud3_4.png" width="100%" height="100%"
                                                preserveAspectRatio="xMidYMid slice"></image>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="desert-half-l desert-half-lz2" style="transform: translate3d(0px, 0px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: absolute; display: block; left: 0px; top: 0px;">
                            <p class="desert-choose-en-m"><span class="intro-txt">{{ $tt('选择') }}</span></p> 
                            <p data-aos="fade-left" data-aos-delay="500" class="desert-qrcode-txt aos-init aos-animate">{{ $tt('手机选版') }}</p> 
                            <p data-aos="fade-left" data-aos-delay="500" class="desert-qrcode"></p> 
                            <p class="desert-creat"><span class="intro-txt">{{ $tt('立即创建您自己的品牌') }}</span></p></div>
                        <b data-depth="0.5" class="obj-1"
                            style="transform: translate3d(-95.7px, 14.3px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: absolute; display: block; left: 0px; top: 0px;"></b>
                        <b data-depth="-0.5" class="obj-2"
                            style="transform: translate3d(95.7px, -14.3px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: absolute; display: block; left: 0px; top: 0px;"></b>
                        <div class="desert-half-l"
                            style="transform: translate3d(0px, 0px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: absolute; display: block; left: 0px; top: 0px;">
                            <div data-aos="fade-left" data-aos-delay="500" class="desert-qrcode-wrap aos-init"></div>
                            <p class="intro-easy">{{ $tt('从此简单') }}</p>
                        </div>
                    </div>
                </div>
                <div class="intro-wrap" v-if="isEnglish()">
                        <div class="intro-text" :class="isEnglish ? 'intro-en' : ''">
                            <p data-aos="fade-right" data-aos-delay="100" class="intro-market intro-txt aos-init aos-animate">
                                {{$tt('拥有市场趋势 高敏 锐 度')}}<br>
                                {{$tt('独特')}} <span class="intro-color-blue">{{$tt('创新')}}</span> {{$tt('的视觉呈')}} <br> {{$tt('现')}}
                                <br>
                                {{ $tt('设') }} <br>{{ $tt('计最具') }} <br><span class="intro-color-blue">{{ $tt('竞争力') }}</span> <br>{{ $tt('的') }}
                                <br>
                                {{ $tt('版') }}
                                <br>
                                {{ $tt('面') }}
                            </p>                       
                            <p data-aos="fade-right" data-aos-delay="350"
                                class="intro-choose intro-txt intro-color-blue aos-init aos-animate">
                                <span class="intro-choose-ins">{{ $tt('选版') }}</span>                            
                            </p>
                        </div>
                    </div>
                <div class="intro-wrap" v-if="!isEnglish()">
                    <div class="intro-text">
                        <p data-aos="fade-right" data-aos-delay="100" class="intro-market intro-txt aos-init aos-animate">
                            {{$tt('拥有市场趋势')}}<span class="intro-letter1">{{$tt('高敏')}}</span><span class="intro-letter-half">{{$tt('锐')}}</span>{{$tt('度')}}</p>
                        <p data-aos="fade-right" data-aos-delay="150" class="intro-unique intro-txt aos-init aos-animate"><span
                                class="intro-letter1">独特<span class="intro-color-blue">创新</span>的视觉呈</span>现</p>
                        <p data-aos="fade-right" data-aos-delay="200" class="intro-brand intro-txt aos-init aos-animate"><span
                                class="intro-letter1">展现个人<span class="intro-letter-half">品牌的</span><span
                                    class="intro-color-blue intro-letter-half">价</span></span><span
                                class="intro-color-blue">值</span></p>
                        <p data-aos="fade-right" data-aos-delay="300" class="intro-design intro-txt aos-init aos-animate"><span
                                class="intro-letter-half"><span class="intro-letter-pd15">设</span>计最具<span
                                    class="intro-color-blue">竞争力</span>的<span class="intro-letter-pd15">版</span></span>面</p>
                        <p data-aos="fade-right" data-aos-delay="350"
                            class="intro-choose intro-txt intro-color-blue aos-init aos-animate"><span
                                class="intro-choose-ins">选版</span> 
                                <!-- <span class="intro-qrcode">
                                    <span
                                    class="qrcode-txt">手机选版</span>
                                </span> -->
                            </p>
                    </div>
                </div>
                
                
                <div class="cloud-wrap">
                    <!-- <div data-aos="fade-down" data-aos-delay="200" class="obj-4 aos-init aos-animate"><b></b></div>
                    <div data-aos="fade-up-right" data-aos-delay="250" class="obj-5 aos-init aos-animate"><b></b></div>
                    <div data-aos="fade-up-right" data-aos-delay="150" class="obj-6 aos-init aos-animate"><b></b></div>
                    <div data-aos="fade-up" data-aos-delay="450" class="obj-7 aos-init aos-animate"><b></b></div>
                    <div data-aos="fade-down" data-aos-delay="350" class="obj-8 aos-init aos-animate"><b></b></div> -->
                    <div class="ball-stage-1">
                        <div class="ball-svg b1_1">
                            <svg>
                                <symbol id="maskArea1_1">
                                    <g id="maskCir1_1" stroke="#FFF" fill="#FFF">
                                        <circle r="60" cx="60" cy="60"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope1_1">
                                    <use xlink:href="#maskArea1_1"></use>
                                </mask>
                                <g mask="url(#maskScope1_1)">
                                    <image xlink:href="../images/cloud1_1.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                        <div class="ball-svg b1_2"><svg>
                                <symbol id="maskArea1_2">
                                    <g id="maskCir1_2" stroke="#FFF" fill="#FFF">
                                        <circle r="75" cx="75" cy="75"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope1_2">
                                    <use xlink:href="#maskArea1_2"></use>
                                </mask>
                                <g mask="url(#maskScope1_2)">
                                    <image xlink:href="../images/cloud1_2.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg></div>
                        <div class="ball-svg b1_3">
                            <svg>
                                <symbol id="maskArea1_3">
                                    <g id="maskCir1_3" stroke="#FFF" fill="#FFF">
                                        <circle r="80" cx="80" cy="80"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope1_3">
                                    <use xlink:href="#maskArea1_3"></use>
                                </mask>
                                <g mask="url(#maskScope1_3)">
                                    <image xlink:href="../images/cloud1_3.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="ball-stage-2">
                        <div class="ball-svg b2_1">
                            <svg>
                                <symbol id="maskArea2_1">
                                    <g id="maskCir2_1" stroke="#FFF" fill="#FFF">
                                        <circle r="90" cx="90" cy="90"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope2_1">
                                    <use xlink:href="#maskArea2_1"></use>
                                </mask>
                                <g mask="url(#maskScope2_1)">
                                    <image xlink:href="../images/cloud2_1.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                        <div class="ball-svg b2_2">
                            <svg>
                                <symbol id="maskArea2_2">
                                    <g id="maskCir2_2" stroke="#FFF" fill="#FFF">
                                        <circle r="110" cx="110" cy="110"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope2_2">
                                    <use xlink:href="#maskArea2_2"></use>
                                </mask>
                                <g mask="url(#maskScope2_2)">
                                    <image xlink:href="../images/cloud2_2.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                        <div class="ball-svg b2_2 for-tablet">
                            <svg>
                                <symbol id="maskArea2_2">
                                    <g id="maskCir2_2" stroke="#FFF" fill="#FFF">
                                        <circle r="110" cx="110" cy="110"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope2_2">
                                    <use xlink:href="#maskArea2_2"></use>
                                </mask>
                                <g mask="url(#maskScope2_2)">
                                    <image xlink:href="../images/cloud2_2t.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                        <div class="ball-svg b2_3">
                            <svg>
                                <symbol id="maskArea2_3">
                                    <g id="maskCir2_3" stroke="#FFF" fill="#FFF">
                                        <circle r="80" cx="80" cy="80"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope2_3">
                                    <use xlink:href="#maskArea2_3"></use>
                                </mask>
                                <g mask="url(#maskScope2_3)">
                                    <image xlink:href="../images/cloud2_3.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                        <div class="ball-svg b2_4">
                            <svg>
                                <symbol id="maskArea2_4">
                                    <g id="maskCir2_4" stroke="#FFF" fill="#FFF">
                                        <circle r="105" cx="105" cy="105"></circle>
                                    </g>
                                </symbol>
                                <mask id="maskScope2_4">
                                    <use xlink:href="#maskArea2_4"></use>
                                </mask>
                                <g mask="url(#maskScope2_4)">
                                    <image xlink:href="../images/cloud2_4.png" width="100%" height="100%"
                                        preserveAspectRatio="xMidYMid slice"></image>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <svg>
                <defs>
                    <filter id="filter">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="18" result="blur"></feGaussianBlur>
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10"
                            result="filter"></feColorMatrix>
                        <feComposite in="SourceGraphic" in2="filter" operator="atop"></feComposite>
                    </filter>
                </defs>
            </svg>
        </section>
        <section
            class="index-filter-wrap"
            :class="filterActive ? 'is-active' : ''"
        >
            <nav class="index-filter-nav">
                <div class="index-filter-link removeTextNodes">
                    <div class="index-filter-item">
                        <button @click="setFilter('all')" data-filter=".is-new" class="index-filter-btn">
                            {{$tt('全部')}}
                        </button>
                    </div>
                    <div class="index-filter-item">
                        <button @click="setFilter('casino')" data-filter=".is-hot" class="index-filter-btn">
                            {{$tt('综合主题')}}
                        </button>
                    </div>
                    <div class="index-filter-item">
                    <span
                        class="index-filter-btn is-selected"
                        @click="setFilter('lottery')"
                        >{{$tt('彩票')}}</span>
                    </div>
                    <div class="index-filter-item">
                        <span @click="setFilter('chess')" class="index-filter-btn">{{$tt('棋牌')}}</span>                        
                    </div>
                    
                </div>
            </nav>
        </section>
        <ListItem></ListItem>
        </main>
        <span class="overlay" 
            :class="getMainActive ? 'is-active' : 
            filterActive ? 'is-active' : ''" @click="hideMenu()"></span>
    </div>
</template>
<style scoped>
@import "../css/aos.css"
</style>

<script type="application/javascript">
import { mapGetters } from "vuex";
import config from '../config';
import ListItem from "../components/ListItem.vue";
import AOS from '../js/aos'
export default {
  data() {
    return {
      isMenuThreeActive: false,
      currentLang: '',
    };
  },
  watch: {
    getFilteredTemplates(newValue, oldValue){

    },    
  },
  components: {
    ListItem
  },
  methods: {
    setFilter(templateFilter){
        this.$store.commit('setFilterActive', false)
        if (templateFilter == "all"){
            this.$store.commit('setActiveTemplateFilter', config.data)
        }
        else if (templateFilter == "casino"){
            this.$store.commit('setActiveTemplateFilter', config.data.filter(x => x.is_casino == true))
        }
        else if (templateFilter == "lottery"){
            this.$store.commit('setActiveTemplateFilter', config.data.filter(x => x.is_lottery == true))
        }
        else if (templateFilter == "chess"){
            this.$store.commit('setActiveTemplateFilter', config.data.filter(x => x.is_chess_card == true))
        }else {
            this.$store.commit('setActiveTemplateFilter', config.data)
        }
    },
   
    isEnglish(){
        let lang = localStorage.getItem('language');
        return lang == 'en';
    },
    getCurrentLang(){
        this.currentLang = localStorage.getItem('language');
        return this.currentLang == 'ch' ? 'colorful-text-lang-ch' : 'colorful-text-lang-en';
    },
    handleMenuThree() {
        setTimeout(() => {
            this.isMenuThreeActive = !this.isMenuThreeActive
        }, 200);
    },
    hideMenu(){
        this.$store.commit('setFilterActive', false)
        this.$store.commit('setMainMenuActive', false)
    },
  },
  computed: {
    ...mapGetters([
      'filterActive',
      'getMainActive',
      'getActiveTemplateFilter'
    ]),
    
  },
  created(){
    this.$store.commit('setActiveTemplateFilter', config.data)
  },
  mounted() {
    this.currentLang = localStorage.getItem('language');
    this.$store.commit('setActiveTemplateFilter', config.data)
    if (this.currentLang == 'en'){
        $('.colorful-title').append('<br>');
    }
    AOS.init({
        once:false,
    })
  },
};
</script>
<style scoped>
.banner > img {
    width: 100%;
    height: 100%;
    display: block;
}
.en-banner {
    position: relative; 
    min-height: 1125px;
    width: 100%;
    background: url("../images/en-banner.png") no-repeat center center
    fixed;
    display: block;
}
.ch-banner {
    position: relative;    
    min-height: 1125px;
    width: 100%;
    background: url("../images/ch-banner.png") no-repeat center center
    fixed;
    display: block;
}

@media only screen and (max-width:991px) {
    .banner > img {
        display: none;
    }
}
</style>